'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwDropdownMulti = require('../cwdropdown/CwDropdownMulti');

var _CwDropdownMulti2 = _interopRequireDefault(_CwDropdownMulti);

var _CwPillTriggerField = require('../cwpilltriggerfield/CwPillTriggerField');

var _CwPillTriggerField2 = _interopRequireDefault(_CwPillTriggerField);

var _CwPill = require('../cwpill/CwPill');

var _CwPill2 = _interopRequireDefault(_CwPill);

var _CwDropdownService = require('../../utils/CwDropdownService');

var _CwMultiSelect = require('./CwMultiSelect.scss');

var _CwMultiSelect2 = _interopRequireDefault(_CwMultiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

var CwMultiSelect = function (_React$Component) {
  (0, _inherits3.default)(CwMultiSelect, _React$Component);

  function CwMultiSelect(props) {
    (0, _classCallCheck3.default)(this, CwMultiSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwMultiSelect.__proto__ || (0, _getPrototypeOf2.default)(CwMultiSelect)).call(this, props));

    _this.highlightItemFromMouse = function (index) {
      _this.setState({ highlightedIndex: index });
    };

    _this.selectItem = function (item) {
      var values = _this.props.value.slice();

      if (item.id === -1 && values.length !== _this.filterExcludedItems(_this.props.items).length) {
        // Select All
        _this.getFilteredItems().forEach(function (element) {
          if (this.findValue(element.id, values) === -1) {
            values.push(element.id);
          }
        }, _this);
      } else if (item.id === -1 && values.length === _this.filterExcludedItems(_this.props.items).length) {
        // Deselect All
        _this.getFilteredItems().forEach(function (element) {
          var valuePosition = this.findValue(element.id, values);
          if (valuePosition !== -1) {
            values.splice(valuePosition, 1);
          }
        }, _this);
      } else {
        var selection = item;
        var valuePosition = _this.findValue(selection.id, values);

        if (valuePosition === -1) {
          values.push(selection.id);
        } else {
          values.splice(valuePosition, 1);
        }
      }

      _this.setState({
        displayText: ''
      });

      _this.props.onChange(values); // Report values selected
      _this.focus();
    };

    _this.setIgnoreBlur = function (ignore) {
      _this._ignoreBlur = ignore;
    };

    _this.handleDropdownEnter = function () {
      _this._ignoreScroll = true;
    };

    _this.handleDropdownLeave = function () {
      _this._ignoreScroll = false;
    };

    _this.handleScroll = function (event) {
      // Hide dropdown when window is scrolled
      if (_this.state.expanded && (event.target === document || !event.target.className.includes('CwDropdownMulti-dropDown'))) {
        _this.setState({
          expanded: false,
          prevExpanded: true
        });
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.keyDownHandlers[event.key]) _this.keyDownHandlers[event.key].call(_this, event);
    };

    _this.handleKeyUp = function () {
      if (_this._performAutoCompleteOnKeyUp) {
        _this._performAutoCompleteOnKeyUp = false;
        _this.autoCompleteText();
      }
    };

    _this.handleChange = function (displayText) {
      _this._performAutoCompleteOnKeyUp = true;
      _this.setState({
        displayText: displayText,
        expanded: true,
        filter: true
      });
    };

    _this.handleInputBlur = function () {
      if (_this._ignoreBlur) return;
      // IE fires a blur event when clicking the scrollbar - this prevents the dropdown from closing
      if (_this.cwDropdown && _this.cwDropdown.isMousedOver()) {
        _this.cwPillTriggerField.focus();
        return;
      }
      _this.setState({
        expanded: false,
        focused: false,
        highlightedIndex: null
      });
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.handleInputFocus = function () {
      if (_this._ignoreBlur) {
        _this.setIgnoreBlur(false);
        return;
      }
      _this.setState({
        focused: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.handleTriggerClick = function () {
      // Expand the full unfiltered dropdown if the trigger is clicked
      if (_this.props.disabled) return;
      _this.focus();
      _this.setState({
        expanded: true,
        filter: false
      });
    };

    _this.closePill = function (key) {
      if (key.id === 'all') {
        _this.selectItem({ id: -1 }); // deselect all
      } else {
        var values = _this.props.value;
        var valuePosition = _this.findValue(key.id, values);
        values.splice(valuePosition, 1);
        _this.props.onChange(values); // Report values selected
      }
      _this.focus();
    };

    _this._ignoreBlur = false;
    _this._ignoreScroll = false;
    _this._performAutoCompleteOnUpdate = false;
    _this._performAutoCompleteOnKeyUp = false;

    _this.state = {
      displayText: '',
      expanded: false,
      highlightedIndex: null,
      filter: true,
      focused: false
    };

    _this.keyDownHandlers = {
      ArrowDown: function ArrowDown(event) {
        // Cycle through list of items on arrow down, updating `highlightedIndex` along the way 
        event.preventDefault(); // prevent window scrolling
        var itemsLength = this.getFilteredItems().length;
        if (!itemsLength) return;
        var highlightedIndex = this.state.highlightedIndex;

        var index = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? -1 : highlightedIndex + 1; // Go back to the top when reaching the end
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index,
          expanded: true,
          filter: true
        });
      },
      ArrowUp: function ArrowUp(event) {
        // Cycle through list of items on arrow up, updating `highlightedIndex` along the way
        event.preventDefault(); // prevent window scrolling
        var itemsLength = this.getFilteredItems().length;
        if (!itemsLength) return;
        var highlightedIndex = this.state.highlightedIndex;

        var index = highlightedIndex === -1 || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1; // Go back to the end when reaching the top
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index,
          expanded: true,
          filter: true
        });
      },
      Backspace: function Backspace() {
        var values = this.props.value;
        if (this.state.displayText === '') {
          if (values.length !== this.filterExcludedItems(this.props.items).length) {
            values.pop();
          } else {
            values.splice(0, values.length); //clear the array
          }
          this.props.onChange(values);
        }
      },
      Enter: function Enter(event) {
        if (this.state.expanded === false) {
          // Menu is closed so there is no selection to accept: do nothing
        } else {
          // Text entered, menu item has been highlighted, and Enter is hit: select menu item
          event.preventDefault();
          var item = this.getFilteredItems()[this.state.highlightedIndex];
          this.selectItem(item);
          this.setState({
            highlightedIndex: null
          });
        }
      },
      Escape: function Escape() {
        this.setState({
          highlightedIndex: null,
          expanded: false
        });
      }
    };
    return _this;
  }

  (0, _createClass3.default)(CwMultiSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._performAutoCompleteOnUpdate = true;
      // If `items` has changed we want to reset `highlightedIndex` since it probably no longer refers to a relevant item
      if (this.props.items !== nextProps.items ||
      // The entries in `items` may have been changed even though the object reference remains the same, double check by seeing if `highlightedIndex` points to an existing item
      this.state.highlightedIndex >= nextProps.items.length) {
        this.setState({ highlightedIndex: null });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.expanded === true && prevState.expanded === false) {
        var menuPositions = (0, _CwDropdownService.setMenuPositions)(this.cwPillTriggerField.getParentDiv());
        this.setState({
          menuTop: menuPositions.menuTop,
          menuLeft: menuPositions.menuLeft,
          menuWidth: menuPositions.menuWidth,
          inputHeight: menuPositions.inputHeight
        });
      }

      if (this.state.expanded && this._performAutoCompleteOnUpdate) {
        this._performAutoCompleteOnUpdate = false;
        this.autoCompleteText();
      }

      if (prevState.expanded !== this.state.expanded) {
        if (this.state.expanded) {
          if (this.props.onExpand) this.props.onExpand(this.state.expanded);
        } else {
          if (this.props.onCollapse) this.props.onCollapse(this.state.expanded);
          var items = this.getFilteredItems();
          if (items.length === 0 || this.state.displayText === '') {
            // If text entered doesn't match any valid items or is empty
            this.setState({
              displayText: ''
            });
          }
        }
      }
    }
  }, {
    key: 'shouldItemRender',
    value: function shouldItemRender(item, enteredText) {
      // Only render items that match up to what has been typed
      return enteredText.toLowerCase() === item.name.substring(0, enteredText.length).toLowerCase();
    }
  }, {
    key: 'filterExcludedItems',
    value: function filterExcludedItems(items) {
      var _this2 = this;

      if (this.props.excludedItems) {
        items = items.filter(function (item) {
          return !_this2.props.excludedItems.includes(item.id);
        });
      }

      return items;
    }
  }, {
    key: 'getFilteredItems',
    value: function getFilteredItems() {
      var _this3 = this;

      var items = this.props.items;

      items = this.filterExcludedItems(items);

      if (this.shouldItemRender && this.state.filter) {
        items = items.filter(function (item) {
          return _this3.shouldItemRender(item, _this3.state.displayText);
        });
      }

      return items;
    }
  }, {
    key: 'autoCompleteText',
    value: function autoCompleteText() {
      if (this.state.displayText === '') return;
      var highlightedIndex = this.state.highlightedIndex;

      var items = this.getFilteredItems();
      if (items.length === 0) return;
      var matchedItem = highlightedIndex !== null ? items[highlightedIndex] : items[0];
      var itemValue = matchedItem.name;
      var itemValueDoesMatch = itemValue.toLowerCase().indexOf(this.state.displayText.toLowerCase()) === 0;
      if (itemValueDoesMatch && highlightedIndex === null) this.setState({ highlightedIndex: 0 });
    }
  }, {
    key: 'findName',
    value: function findName(id, items) {
      var i;
      for (i = 0; i < items.length; i++) {
        if (items[i].id === id) {
          return items[i].name;
        }
      }
    }
  }, {
    key: 'findValue',
    value: function findValue(id, values) {
      var i;
      for (i = 0; i < values.length; i++) {
        if (values[i] === id) {
          return i;
        }
      }
      return -1;
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.cwPillTriggerField.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var dropdownSettings = {
        top: this.state.menuTop,
        itemHeight: 48,
        inputHeight: this.state.inputHeight,
        maxItemsPerPage: 10,
        numOfItems: this.getFilteredItems().length,
        numOfExtraItems: 1
      };

      var dropdownPosition = (0, _CwDropdownService.calcDropdownPosition)(dropdownSettings);

      var style = { // Pass calculated position coordinates to dropdown with inline style
        left: this.state.menuLeft,
        top: dropdownPosition.top,
        minWidth: this.state.menuWidth,
        height: dropdownPosition.menuHeight
      };

      var values = this.props.value;
      var zeroPosition = this.findValue(0, values);
      if (zeroPosition !== -1) {
        values.splice(zeroPosition, 1);
      }
      var pills = [];
      var allSelected = false;
      var noneSelected = false;

      if (values.length === this.filterExcludedItems(this.props.items).length && values.length > 0) {
        pills.push(_react2.default.createElement(_CwPill2.default, {
          id: 'all',
          key: 'all',
          value: this.props.allPillText,
          onDeletePill: this.closePill,
          deletePillIcon: this.props.closePillIcon
        }));
        allSelected = true;
      } else if (values.length === 0) {
        noneSelected = true;
      } else {
        values.forEach(function (element) {
          pills.push(_react2.default.createElement(_CwPill2.default, {
            id: element,
            key: element,
            value: this.findName(element, this.props.items) + ' ',
            onDeletePill: this.closePill,
            deletePillIcon: this.props.closePillIcon }));
        }, this);
      }

      var cwMultiSelectStyle = void 0;

      if (this.props.invalid) {
        cwMultiSelectStyle = _CwMultiSelect2.default.cwMultiSelectStyleInvalid;
      } else if (this.props.disabled) {
        cwMultiSelectStyle = _CwMultiSelect2.default.cwMultiSelectStyleDisabled;
      } else {
        cwMultiSelectStyle = this.state.focused ? _CwMultiSelect2.default.cwMultiSelectStyleFocused : _CwMultiSelect2.default.cwMultiSelectStyle;
      }

      return _react2.default.createElement(
        _CwPillTriggerField2.default,
        {
          cwId: this.props.cwId,
          style: cwMultiSelectStyle,
          ref: function ref(input) {
            return _this4.cwPillTriggerField = input;
          },
          triggerIcon: this.props.triggerIcon,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          disabled: this.props.disabled,
          invalid: this.props.invalid,
          handleTriggerClick: this.handleTriggerClick,
          pills: this.props.disabled ? [] : pills,
          value: this.state.displayText
        },
        this.state.expanded && this.getFilteredItems().length > 0 ? _react2.default.createElement(_CwDropdownMulti2.default, {
          items: this.getFilteredItems(),
          value: this.props.value,
          highlightedIndex: this.state.highlightedIndex,
          style: style,
          onClick: this.selectItem,
          onMouseEnter: this.highlightItemFromMouse,
          onMouseDown: this.setIgnoreBlur // Ignore blur to prevent menu from de-rendering before we can process click
          , onMouseUp: this.setIgnoreBlur(false),
          filter: this.state.filter,
          pickerText: this.props.pickerText,
          allSelected: allSelected,
          noneSelected: noneSelected,
          selectAllText: this.props.selectAllText,
          ref: function ref(dropdown) {
            return _this4.cwDropdown = dropdown;
          }
        }) : null
      );
    }
  }]);
  return CwMultiSelect;
}(_react2.default.Component);

CwMultiSelect.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Path to trigger icon
   */
  triggerIcon: _propTypes2.default.string,
  /**
   * Path to pill close icon
   */
  closePillIcon: _propTypes2.default.string,
  /**
   * Formatted value for 'All' based on current locale
   */
  allPillText: _propTypes2.default.string.isRequired,
  /**
   * Array of items to be listed in the dropdown menu. Must contain at least "id" and "name" fields.
   */
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    name: _propTypes2.default.string
  })),
  /**
   * Represents the item that has been selected from the list (or string of custom item entered in if allowCustomEntry set to true). Returns an object {id,name} by default.
   */
  value: _propTypes2.default.any,
  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when combobox's dropdown menu is expanded
   */
  onExpand: _propTypes2.default.func,
  /**
   * Callback function that is fired when combobox's dropdown menu is collapsed
   */
  onCollapse: _propTypes2.default.func,
  /**
   * Used to control if combobox is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable combobox
   */
  disabled: _propTypes2.default.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Localized text for the Select All option
   */
  selectAllText: _propTypes2.default.string.isRequired,
  /**
   * Items to be excluded from the dropdown
   */
  excludedItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))
};

CwMultiSelect.defaultProps = {
  value: []
};

exports.default = CwMultiSelect;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwmultiselect/CwMultiSelect.js
// module id = 841
// module chunks = 10